<template>
  <header>
    <img src="../assets/logo-pepz.svg" alt="logo pepz">
    <h2>Estimation des aides locales</h2>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style lang="scss">
h2 {
  font-weight: 700;
  margin-top: $v-spacer-md;
  margin-bottom: 0;
}
</style>
